module.exports = __webpack_public_path__ + "images/alphabet_smallc8236f0295be8c3686aa00350657f172.png";